<template>
  <div
    ref="videoWrapper"
    class="video-wrapper"
    :class="{ fullscreen: fullscreen }"
    @touchstart="preventZoom"
  >
    <div
      class="loadingPage"
      :class="{ 'has-thumb': !!previewImage, loading: loadingState }"
    >
      <div
        class="loadingPageThumb"
        v-if="previewImage"
        :style="
          previewImage ? { backgroundImage: `url(${previewImage})` } : null
        "
      ></div>
      <div class="loading-holder">
        <p>{{ camera.name }}</p>
        <div>
          <loading-wheel
            :key="`${camera.id}-${reconnectCount}`"
            class="loading"
            :initial-message="
              reconnectCount <= 0 ? 'Connecting...' : 'Reconnecting'
            "
            :hide-bar="true"
            :hide-late-bar="true"
            :time="30"
            :slowTime="60"
          />
        </div>
        <div style="height: 1px; width: 1px"><!--Empty--></div>
      </div>
    </div>

    <canvas
      class="canvas"
      ref="canvas"
      v-shown="setupCanvas"
      v-if="showCanvas"
    ></canvas>
    <video
      class="video"
      ref="video"
      :poster="previewImage || '../assets/black.jpeg'"
      playsinline
      autoplay
      muted
    ></video>
    <div class="tapBack" v-if="showCanvas">
      <div @click="backTap"></div>
      <div @click="forwardTap"></div>
    </div>

    <div class="mediaTools" ref="mediaTools">
      <div class="startButtons">
        <button @click="openPopper" class="calendar">
          <span
            class="time-text"
            :class="{
              'hide-time-text': lastTimeStamp == 0 || loadingState,
            }"
          >
            {{ displayDate }}
          </span>
        </button>
        <input
          class="picker"
          ref="datetimePicker"
          type="datetime-local"
          v-model="dateTime"
          @change="seekToTime"
          :max="new Date().toISOString().split('.')[0]"
        />
      </div>

      <!-- <PTZ /> -->

      <div class="center-buttons">
        <button
          class="rewind"
          @click="rewind({ rel: -20000, pause: 200 })"
        ></button>
        <button
          class="playPause"
          :class="playingState(userPaused)"
          @click="togglePlay"
        ></button>
        <button
          class="fast-forward"
          @click="fastForward({ rel: 20000 })"
        ></button>
      </div>

      <!--
        <span class="time-text" >{{ bitrate}}kbps</span>
         
        <input  @change="changeBitrate" type="range" class="range" min="200" max="10000" v-model.number="bitrate" >
        -->
      <!-- <input @change="scrubAction" type="range" class="range" v-model.number="scrubber" > -->

      <!-- <div class="stats">
          <div>{{connectionState}} {{stalled ? "stalled" : ""}}</div>
          <div>Decoded: {{framesDecoded}}&nbsp;frames</div>
          <div>Nack: {{nackCount}}&nbsp;packets</div>
          <div>RTT: {{rtt}}&nbsp;ms</div> -->
      <!-- <div>RTP RX: {{rxBytesPerSecond}}&nbsp;kB/s</div> -->
      <!-- <div>RX: {{rxIceBytesPerSecond}}&nbsp;kB/s</div> -->
      <!-- <button class="TxMaxButton" @click="setTxMax()">Set TX Max</button> -->
      <!-- </div> -->

      <div class="endButtons">
        <div class="nav-buttons">
          <button
            class="nav-btn prev-cam"
            @click="prevCam"
            aria-label="Previous camera"
            title="Previous camera"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M10 3.5a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 1 0v2A1.5 1.5 0 0 1 9.5 14h-8A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h8A1.5 1.5 0 0 1 11 3.5v2a.5.5 0 0 1-1 0z"
              />
              <path
                fill-rule="evenodd"
                d="M4.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H14.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708z"
              />
            </svg>
          </button>
          <button
            class="nav-btn next-cam"
            @click="nextCam"
            aria-label="Next camera"
            title="Next camera"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
              />
              <path
                fill-rule="evenodd"
                d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
              />
            </svg>
          </button>
        </div>
        <button class="Lv" @click="lvMode" :class="playmodeFilter(playmode)">
          Live
        </button>
        <button
          class="fsButton"
          :class="{ efs: fullscreen }"
          @click="toggleFullScreen"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
  // import { set, keys } from 'idb-keyval';

  import adapter from 'webrtc-adapter';
  // import Janus from '../../public/janus';
  import Janus from '@/utils/janus';
  // import awsInfo from '../../public/websocket';
  import awsInfo from '@/utils/websocket';
  import LoadingWheel from './LoadingWheel.vue';

  import { get, set } from 'idb-keyval';

  //import PTZ from '@/components/PTZ.vue';

  export default {
    directives: {
      shown: {
        mounted: (el, binding, vnode) => {
          //OLD: const func = vnode.context[binding.expression];
          const func = binding.value;
          if (typeof func === 'function') func(el, vnode.key);
        },
      },
    },
    computed: {
      selectedEvent() {
        return this.$store.getters.selectedEvent;
      },
      filterTime() {
        return this.$store.getters.filterTime;
      },
      playingState() {
        return (playing) => {
          if (playing === true) {
            return 'pause';
          }
          return 'play';
        };
      },
      playmodeFilter() {
        return (playmode) => {
          if (playmode === 'lv') {
            return 'redHighlight';
          }
          return false;
        };
      },
      eventTo() {
        return this.$store.getters.eventTo;
      },
      displayDate() {
        if (this.userPaused && this.userPausedAt)
          return this.formatDate(new Date(this.userPausedAt));
        const date = this.parseDateTime(this.currentDate);
        return this.formatDate(date);
      },
      rememberedTime() {
        return this.$store.getters.rememberedTime;
      },
      eventsReversed() {
        return this.$store.getters.eventsReverse;
      },
      filteredEvents() {
        // Mask bits: 1 = car (v), 2 = person (p); 0 = no filter (show all)
        const mask = Number(this.eventTypes) || 0;
        if (!mask) return this.eventsReversed;

        return this.eventsReversed.filter((evt) => {
          const t = evt?.data?.t?.s; // 'p','v','e','m', etc.
          if (t === 'p') return (mask & 2) !== 0; // person
          if (t === 'v') return (mask & 1) !== 0; // car
          return true;
        });
      },
      Camera() {
        console.log(`CAMERA: ${this.camera.name}`);
        return this.camera;
      },
      currentTimeRecent() {
        const currentTime = this.parseDateTime(this.currentDate);
        return currentTime.getTime() / 1000;
      },
      loadingState() {
        // Check if the 'playing video' is from this millenia
        const recentVideo = this.currentTimeRecent > 3600 * 24 * 365 * 30;
        return (
          this.loading ||
          this.bufferingOrStopped ||
          this.resettingJanus ||
          !recentVideo
        );
      },
    },
    components: {
      LoadingWheel,
      // PTZ,
    },
    name: 'LiveVideo',
    props: ['camera', 'controlIFrameMode', 'holywoodMode', 'eventTypes'],
    data() {
      return {
        mountedTimeout: null,
        janus: null,
        server: 'wss://127.0.0.1/janus',
        streaming: null,
        error: '',
        lifetimer: null,
        capturingImage: false,
        loading: true,
        playing: null,
        scrubber: 50,
        bitrate: 1000,
        dbTap: false,
        dataChannelOpen: false,
        seekTask: null,
        ignoreTimestampMessages: 0,
        lastTimeStamp: 0,
        playmode: 'lv',
        showCanvas: false,
        previewExists: false,
        previewImage: null,
        fullscreen: false,
        showPopper: false,
        dateTime: '',
        thumbnailTimer: -1,
        clipStatus: 'not-created',
        currentDate: '1.1.1970 00:00:00',
        connectionTimer: -1,
        connectionRetries: 0,
        connectionEstablished: false,
        txMax: '500kbps',
        statsTimer: null,
        nackCount: 0,
        lastNackCount: 0,
        rtt: 0,
        lost: 0,
        framesDecoded: 0,
        lastFramesDecoded: 0,
        connectionState: '',
        stalled: true,
        sendStalled: false,
        lastStalled: false,
        rxBytesPerSecond: 0,
        previousBytesReceived: 0,
        previousTimestamp: 0,
        rxIceBytesPerSecond: 0,
        previousIceBytesReceived: 0,
        previousIceTimestamp: 0,
        resettingJanus: false,
        hardResetBackoffMs: 1500,
        bufferingOrStopped: true,
        loadGuardTimeoutId: -1,
        loadGuardStartDate: '',
        hardResetDoneByCamera: '',
        streamCameraId: '',
        streamReadySince: 0,
        captureBlockUntil: 0,
        attachTimerId: -1,
        attachScheduledCamId: null,
        attachDebounceMs: 1000,
        reconnectCount: -1,
        reconnectGraceTimer: null,
        janusPaused: true,
        userPaused: false,
        userPausedAt: 0,
        userPauseIgnoredCount: 0,
      };
    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
      this.setPreviewExists();
      this.mountedTimeout = setTimeout(() => {
        awsInfo.liveView(this.camera.id);
        this.initJanus();
        this.$refs.video.addEventListener('play', this.handlePlay);
        document.addEventListener(
          'fullscreenchange',
          this.handleFullscreenEvent
        );
        window.Janus = Janus;
      }, 1000);
    },
    beforeUnmount() {
      clearTimeout(this.mountedTimeout);
      this.stopStats();
      this.stopThumbnailTimer();
      try {
        if (this.previewExists === false || this.playmode === 'lv')
          this.captureImage(this.camera);
      } catch (e) {
        console.error('beforeDestroy captureImage: ', e);
      }
      try {
        this.switchToLiveview();
      } catch (e) {
        console.error('beforeDestroy switchToLiveview: ', e);
      }
      try {
        this.stopStream();
      } catch (e) {
        console.error('beforeDestroy stopStream: ', e);
      }
      if (this.janus) this.janus.destroy();
      if (this.lifetimer != null) clearTimeout(this.lifetimer);
      this.$refs.video.removeEventListener('play', this.handlePlay);
      window.removeEventListener('resize', this.handleResize);
      try {
        document.removeEventListener(
          'fullscreenchange',
          this.handleFullscreenEvent
        );
      } catch (e) {
        console.error(e);
      }
      console.log('[Debug] Clean up');
      window.removeEventListener('keydown', this.handleKeys, { capture: true });
      if (this.attachTimerId !== -1) {
        clearTimeout(this.attachTimerId);
        this.attachTimerId = -1;
      }
    },
    unmounted() {
      this.clearOverlay();
      clearTimeout(this.reconnectGraceTimer);
    },
    watch: {
      showCanvas(value) {
        if (value) this.captureImage();
      },
      selectedEvent() {
        if (this.selectedEvent === null) {
          console.log('no selected event');
        } else {
          const date = this.parseDateTime(this.currentDate);
          const forward = this.selectedEvent >= date.getTime();

          this.playmode = 'vt';

          // Build data payload and ensure resume if currently paused
          const data = { abs: this.selectedEvent, forward };
          if (this.userPaused) {
            this.userPaused = false;
            this.userPausedAt = 0;
            data.pause = 0; // request resume
          }

          const message = {
            topic: 'cmd/devices/hilary-dev/data-channel-relay',
            destination: 'mplay',
            action: { command: 'vt', data },
          };
          this.sendData(message);
        }
      },
      loading() {
        this.$emit('cameraLoading', this.loading);
        if (this.loading === false) {
          setTimeout(() => {
            this.filter();
          }, 1000);
        }
      },
      filterTime() {
        // if (this.loading == true) return
        this.filter();
      },
      eventTo() {
        this.filter();
      },
      scrubber(v) {
        if (v !== 50) {
          const amount = v - 50;
          console.log(amount);
          if (this.seekTask == null) this.startSeekTask();
        } else {
          this.stopSeekTask();
        }
      },
      camera(newCam, oldCam) {
        console.log('value: ', newCam);
        console.log('old value: ', oldCam);
        this.captureBlockUntil = Date.now() + 1000;
        this.streamCameraId = '';
        this.loading = true;
        this.setPreviewExists();

        // stop any current stream right away to free resources / show overlay
        this.stopThumbnailTimer();
        this.stopStream();
        if (this.lifetimer != null) clearTimeout(this.lifetimer);

        if (this.attachTimerId !== -1) {
          clearTimeout(this.attachTimerId);
          this.attachTimerId = -1;
        }

        // If we don't have a real camera yet, cancel and bail.
        if (!newCam || !newCam.id) {
          if (this.attachTimerId !== -1) {
            clearTimeout(this.attachTimerId);
            this.attachTimerId = -1;
          }
          this.attachScheduledCamId = null;
          return;
        }

        this.attachScheduledCamId = newCam.id;

        this.attachTimerId = setTimeout(() => {
          this.attachTimerId = -1;

          const id = this.camera?.id;
          if (!id) return;
          if (id !== this.attachScheduledCamId) {
            console.log(
              '[Debounce] Skipping attach for stale camera:',
              this.attachScheduledCamId
            );
            return;
          }

          try {
            awsInfo.liveView(id);
          } catch (e) {
            console.warn('liveView failed', e);
          }

          // Proceed to attach Janus for the *current* camera
          this.attachJanus();
        }, this.attachDebounceMs);
      },
      playmode(value) {
        this.$emit('playmode', value);
      },
      connectionEstablished(value) {
        if (value) {
          this.getMediaReports();
        }
      },
      controlIFrameMode(newValue, oldValue) {
        console.log(
          `controlIFrameMode changed from ${oldValue} to ${newValue}`
        );
      },
      holywoodMode(newValue, oldValue) {
        console.log(`holywoodMode changed from ${oldValue} to ${newValue}`);
      },
      currentDate(newValue) {
        if (this.userPausedAt) this.$emit('dateChange', this.userPausedAt);
        else this.$emit('dateChange', this.parseDateTime(newValue).getTime());
      },
    },
    methods: {
      prevCam() {
        this.$emit('prevCam');
      },
      nextCam() {
        this.$emit('nextCam');
      },
      async setPreviewExists() {
        this.previewExists = await this.havePhoto(this.camera?.id);
        if (!this.previewExists) this.previewImage = null;
        console.log('previewExists:', this.previewExists);
      },
      lvMode() {
        console.log('hello switcherRRRRRRRR');
        // CHANGE TO LIVE VIEW MODE
        this.switchToLiveview();
      },
      // Tap to go back
      backTap() {
        if (this.dbTap) {
          console.log('back');
          this.dbTap = false;
        } else this.dbTap = true;
        setTimeout(() => {
          this.dbTap = false;
        }, 500);
      },
      // Tap to go forward
      forwardTap() {
        if (this.dbTap) {
          console.log('forward');
          this.dbTap = false;
        } else this.dbTap = true;
        setTimeout(() => {
          this.dbTap = false;
        }, 500);
      },
      // Prevents double tapping causing user to zoom preventing action
      preventZoom(e) {
        const t2 = e.timeStamp;
        const t1 = e.currentTarget.dataset.lastTouch || t2;
        const dt = t2 - t1;
        const fingers = e.touches.length;
        e.currentTarget.dataset.lastTouch = t2;

        if (!dt || dt > 500 || fingers > 1) return; // not double-tap

        e.preventDefault();
        e.target.click();
      },
      changeBitrate(e) {
        console.log('change bitrate handler.', e, this.bitrate);
        this.sendBitrate(this.bitrate);
      },
      scrubAction() {
        this.scrubber = 50;
      },
      togglePlay() {
        this.playing = !this.playing;
        if (this.playing === true) {
          if (this.playmode == 'lv') this.pause(0, true);
          else this.pause();
        } else {
          this.play();
        }
      },
      stopStats() {
        if (this.statsTimer) {
          clearTimeout(this.statsTimer);
          this.statsTimer = null;
        }
      },
      startStats() {
        if (!this.statsTimer)
          this.statsTimer = setTimeout(this.getWebRTCStats, 500);
      },
      initJanus() {
        Janus.init({
          debug: 'warn',
          dependencies: Janus.useDefaultDependencies({ adapter }),
          callback: () => this.createJanusInstance(),
        });
      },
      createJanusInstance() {
        const component = this;

        if (!Janus.isWebrtcSupported()) {
          this.error = 'No WebRTC support... ';
          return;
        }

        this.janus = new Janus({
          server: this.server,
          apisecret: 'a2a2a2',
          iceServers: [
            { urls: 'stun:megakam.com:3478' },
            {
              urls: 'turn:megakam.com:3478?transport=udp',
              username: 'myuser',
              credential: 'mypass',
            },
          ],
          success: () => {
            component.attachJanus();
          },
          error: (error) => {
            console.log('[Janus] Error (create): ', error);
          },
        });
      },
      attachJanus() {
        const component = this;

        this.janus.attach({
          plugin: 'janus.plugin.streaming',
          opaqueId: 'tempest-1',

          success: (pluginHandle) => {
            console.debug('[Janus] Janus Sessions: ', Janus.sessions);
            component.streaming = pluginHandle;
            console.debug('[Janus] Plugin Handle: ', pluginHandle);
            component.startStream();
          },

          error: (error) => {
            console.log('[Janus] Error (attach): ', error);
            if (
              error.includes('server down') ||
              error.includes('458 No such session')
            )
              component.hardResetJanusSession(error);
          },

          mediaState: function (medium, on) {
            console.debug('[Janus] MediaState:', medium, on);
            if (medium === 'video' && on === false) {
              component.hardResetJanusSession('mediaState video stopped');
            }
          },

          webrtcState: (on) => {
            if (on) {
              // Connected at the WebRTC layer; still negotiating/buffering until frames
              if (this.videoState !== 'playing') this.setState?.('negotiating');
            } else {
              console.warn('Video stream disconnected');
            }
          },

          onremotetrack: (track, mid, added, metadata) => {
            console.debug('[Janus] Added: ', added);
            console.debug('[Janus] metadata: ', metadata);
          },

          onmessage: (msg, jsep) => {
            try {
              const pluginData = msg?.pluginData?.data || {};
              const status =
                pluginData?.result?.status ||
                pluginData?.status ||
                msg?.result?.status;
              if (status) {
                const s = String(status).toLowerCase();
                if (s === 'stopped' || s === 'stopping' || s === 'paused') {
                  try {
                    this.streaming?.hangup();
                  } catch {
                    /* Ignore */
                  }
                  this.setState?.('connecting');
                  setTimeout(() => this.startStream?.(), 100);
                }
              }
            } catch (e) {
              console.warn('[Janus] Status parse failed', e);
            }
            if (jsep) {
              this.setState?.('negotiating');
              this.streaming.createAnswer({
                jsep,
                media: { audioSend: false, videoSend: false, data: true },
                success: (receiveJsep) => {
                  const body = { request: 'start' };
                  this.streaming.send({ message: body, jsep: receiveJsep });
                  this.setState?.('buffering'); // until <video> actually plays
                },
                error: (error) => {
                  Janus.error('[Janus] WebRTC error:', error);
                  this.error = 'An error has occurred.';
                },
              });
            }
          },

          onremotestream: (stream) => {
            console.log('ON REMOTE STREAM', stream);
            Janus.attachMediaStream(component.$refs.video, stream);
            this.streamCameraId = this.camera?.id || '';
            this.streamReadySince = Date.now();
            this.captureBlockUntil = this.streamReadySince + 1000;
            const video = this.$refs.video;
            const videoOnPlaying = () => {
              clearTimeout(this.reconnectGraceTimer);
              this.reconnectGraceTimer = null;
              this.bufferingOrStopped = false;
              this.loading = false;
              if (this.reconnectCount <= 0) this.reconnectCount = 0;
              video.removeEventListener('playing', videoOnPlaying);
            };
            video?.addEventListener('playing', videoOnPlaying, { once: true });
            stream.getTracks().forEach((t) => {
              t?.addEventListener('mute', (ev) => {
                if (this.reconnectCount >= 0 && !this.userPaused)
                  this.reconnectGraceTimer = setTimeout(() => {
                    console.warn('[Janus] Reconnect grace timer expired.');
                    component.bufferingOrStopped = true;
                    this.loading = true;
                    this.reconnectCount += 1;
                  }, 10000);
                console.log('[Janus] Track muted:', ev.target.kind);
                this.janusPaused = true;
              });
              t?.addEventListener('unmute', (ev) => {
                clearTimeout(this.reconnectGraceTimer);
                this.reconnectGraceTimer = null;
                this.bufferingOrStopped = this.connectionState != 'connected';
                this.loading = false;
                console.log('[Janus] Track unmuted:', ev.target.kind);
                this.janusPaused = false;
              });
            });
          },

          iceState: function (state) {
            console.log('ICE Connection State Change:', state);
            component.connectionState = state;

            if (state === 'failed' || state === 'disconnected') {
              component.stopStats();
              console.warn(`ICE (Connectivity) error: ${state}`);
              // Try a soft re-watch after a brief delay
              setTimeout(() => {
                try {
                  component.streaming?.hangup();
                } catch {
                  /* Ignore */
                }
                component.startStream?.();
              }, 300);
              return;
            }
          },

          ondataopen: (data) => {
            this.dataChannelOpen = true;
            console.log('Data Channel opened with data: ', data);
            this.startConnectionTimer();
            this.$emit('sessionId', this.janus.getSessionId());
            window?.addEventListener('keydown', this.handleKeys, {
              capture: true,
            });
          },

          ondata: (msg) => {
            const data = JSON.parse(msg);
            if (
              data.events &&
              data.events[0] &&
              data.events[0].event === 'id'
            ) {
              this.$store.dispatch('changeEvents', msg);
            }
            this.processData(msg);
          },

          oncleanup: () => {
            // Peer connection cleaned up by Janus; keep the session & plugin handle
            if (this.videoState !== 'error') {
              this.setState?.('connecting');
            }
          },

          detached() {
            console.debug('[Janus] detached');
          },

          slowLink: function (uplink, lost) {
            // `uplink` will tell you if the slow link concerns the uplink (true) or downlink (false)
            // `lost` will tell you if packets were lost (true) or just out of order (false)

            // console.log("Slow link detected. Uplink:", uplink, "Lost:", lost);

            if (uplink && lost) {
              component.lost += lost;
            }
          },
        });
      },

      // To get WebRTC stats
      getWebRTCStats() {
        let nackCount = 0;
        let roundTripTime = 0;
        let framesDecoded = 0;

        const janusStream = this.streaming;
        if (
          janusStream &&
          janusStream.webrtcStuff &&
          janusStream.webrtcStuff.pc
        ) {
          let pc = janusStream.webrtcStuff.pc;
          pc.getStats(null)
            .then((stats) => {
              stats.forEach((report) => {
                if (report.type === 'inbound-rtp') {
                  if ('nackCount' in report) {
                    nackCount = report.nackCount;
                  }

                  if ('framesDecoded' in report) {
                    framesDecoded = report.framesDecoded;
                  }

                  if ('timestamp' in report) {
                    // lastRtpTimestamp = report.timestamp;
                  }

                  if ('pliCount' in report) {
                    // pliCount = report.pliCount;
                  }
                }

                if (report.type === 'candidate-pair') {
                  if ('currentRoundTripTime' in report) {
                    roundTripTime = report.currentRoundTripTime * 1000; // Convert to milliseconds
                  }
                }

                if (
                  report.type === 'inbound-rtp' &&
                  report.mediaType === 'video'
                ) {
                  const currentTime = Date.now();
                  const elapsedSeconds =
                    (currentTime - this.previousTimestamp) / 1000;
                  const bytesReceived = report.bytesReceived;

                  const bytesPerSecond =
                    (bytesReceived - this.previousBytesReceived) /
                    elapsedSeconds;
                  this.rxBytesPerSecond = (bytesPerSecond / 1024).toFixed(0);

                  this.previousBytesReceived = bytesReceived;
                  this.previousTimestamp = currentTime;
                }

                if (report.type === 'transport') {
                  const currentTime = Date.now();
                  const elapsedSeconds =
                    (currentTime - this.previousIceTimestamp) / 1000;
                  const bytesReceived = report.bytesReceived;

                  const bytesPerSecond =
                    (bytesReceived - this.previousIceBytesReceived) /
                    elapsedSeconds;
                  this.rxIceBytesPerSecond = (bytesPerSecond / 1024).toFixed(0);

                  this.previousIceBytesReceived = bytesReceived;
                  this.previousIceTimestamp = currentTime;
                }
              });

              this.nackCount = nackCount;
              this.framesDecoded = framesDecoded;
              this.rtt = roundTripTime;

              if (this.lastFramesDecoded === this.framesDecoded)
                this.stalled = true;
              else this.stalled = false;

              this.lastFramesDecoded = framesDecoded;
              this.lastNackCount = nackCount;

              // If the video has played at least one frame then it can be
              // throttled.
              if (this.framesDecoded > 0) {
                // If the janus data channel is connected...
                if (this.connectionState === 'connected') {
                  // If a stall has been detected...
                  if (this.stalled) {
                    if (this.controlIFrameMode) {
                      // Send the control message to mplay
                      this.sendIFrameMode(true);
                    }
                  }
                }
              }

              // If stalled then check again in 35 seconds, otherwise
              // if not stalled then check again in 1 second.
              if (this.stalled && this.controlIFrameMode)
                this.statsTimer = setTimeout(this.getWebRTCStats, 35000);
              else this.statsTimer = setTimeout(this.getWebRTCStats, 1000);
            })
            .catch((error) => {
              console.error('Failed to get stats', error);
            });
        }
      },

      startStream() {
        console.log('START STREAM');
        const body = { request: 'watch', id: 1 };
        this.streaming.send({ message: body });
      },
      stopStream() {
        this.stopStats();
        if (this.streaming) {
          try {
            const body = { request: 'stop' };
            this.streaming.send({ message: body });
          } catch (e) {
            /* ignore */
          }
          try {
            this.streaming.hangup();
          } catch (e) {
            /* ignore */
          }
          try {
            this.streaming.detach();
          } catch (e) {
            /* ignore */
          }
          this.streaming = null;
        }
      },
      handlePlay() {
        this.startStats();
        this.$emit('connected');
        if (this.showCanvas === false) {
          this.showCanvas = true;
        } else {
          this.setupCanvas(true);
        }
        this.startThumbnailTimer();
      },
      handleResize() {
        if (this.showCanvas === false) {
          this.showCanvas = true;
        } else {
          this.setupCanvas();
        }
      },
      setupCanvas(takePhoto) {
        console.debug('Setup Canvas');
        if (this.ctx == null) this.ctx = this.$refs.canvas?.getContext('2d');

        const video = this.$refs.video;
        const videoContainer = this.$refs.videoWrapper;
        const toolbar = this.$refs.mediaTools;

        var { scaledWidth, scaledHeight } = this.calculateVideoSize(
          video.offsetWidth,
          video.offsetHeight,
          video.videoWidth,
          video.videoHeight
        );
        console.debug('video.client = ', video.clientWidth, video.clientHeight);
        console.debug('video = ', video.videoWidth, video.videoHeight);
        console.debug('Scaled video size = ', scaledWidth, scaledHeight);

        const canvas = this.$refs.canvas;
        canvas.width = Math.floor(scaledWidth);
        canvas.height = Math.floor(scaledHeight);
        console.debug('Canvas size = ', canvas.width, canvas.height);

        // Offset  canvas vertically
        const offsetY =
          (videoContainer.offsetHeight - canvas.height - toolbar.offsetHeight) /
          2;
        canvas.style.top = `${Math.floor(offsetY)}px`;

        // Offset  canvas horizontally to center
        const offsetX = (videoContainer.offsetWidth - canvas.width) / 2;
        canvas.style.left = `${Math.floor(offsetX)}px`;

        if (takePhoto == true || typeof takePhoto == 'object') {
          this.captureImage();
        }
      },
      drawOverlay() {
        if (!this.holywoodMode) {
          return;
        }

        // If no objects detected then exit
        if (!awsInfo.objectDetections || !awsInfo.objectDetections.length)
          return;

        // Schedule to clear the overlay after 1 second with no updates.
        // And cancel prior timer if already running.
        const colours = [
          'red',
          'lightgreen',
          'lightblue',
          'orange',
          'magenta',
          'yellow',
          'cyan',
        ];
        if (this.lifetimer) window.clearTimeout(this.lifetimer);
        this.lifetimer = window.setTimeout(this.clearOverlay, 1000);

        let vw = 0;
        let vh = 0;
        const c = this.$refs.canvas;
        const v = this.$refs.video;

        if (v === null || v.videoWidth === 0 || v.videoHeight === 0) {
          return;
        }

        vw = v.videoWidth;
        vh = v.videoHeight;
        // const vr = vw / vh;

        if (!this.ctx) return;

        const g = this.ctx;
        g.clearRect(0, 0, c.width, c.height);

        g.lineWidth = 1.5;
        g.font = '20px Arial';

        try {
          const obs = awsInfo.objectDetections;
          let i = 0;
          if (obs) {
            obs.forEach((o) => {
              const colour = colours[i % colours.length];
              g.strokeStyle = colour;
              g.fillStyle = colour;

              const sx = (o.xmin / vw) * c.width;
              const sy = (o.ymin / vh) * c.height;
              const sw = (o.xmax / vw) * c.width;
              const sh = (o.ymax / vh) * c.height;

              if (this.holywoodMode & 1) g.strokeRect(sx, sy, sw - sx, sh - sy);

              if (this.holywoodMode & 2)
                g.fillText(`${o.class} ${o.confidence}%`, sx + 2, sy - 10);
            });
            i += 1;
          }
        } catch (e) {
          console.log(e);
        }
      },
      clearOverlay() {
        awsInfo.objectDetections = null;
        if (this.ctx == null) return;
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      },
      captureImage(camera) {
        if (!this.holywoodMode) {
          return;
        }
        const target = camera ?? this.camera;
        const vid = this.$refs.video;

        if (!target || !target.id) return;
        if (Date.now() < this.captureBlockUntil) return;
        if (this.streamCameraId !== target.id) return;
        if (
          !vid ||
          vid.readyState < 2 ||
          vid.videoWidth <= 400 ||
          vid.videoHeight <= 400
        ) {
          return; // not ready to grab a good frame
        }
        this.capturingImage = true;
        this.clearOverlay();
        if (this.ctx) {
          const TargetThumbWidth = 260;
          const TargetThumbHeight = 130; // Height of the thumbnails
          const vw = vid.videoWidth;
          const vh = vid.videoHeight;
          const scale = Math.min(
            TargetThumbWidth / vw,
            TargetThumbHeight / vh,
            1
          ); // never upscale
          const outW = Math.max(1, Math.floor(vw * scale));
          const outH = Math.max(1, Math.floor(vh * scale));

          const canvas = this.ctx.canvas;
          const prevW = canvas.width;
          const prevH = canvas.height;

          canvas.width = outW;
          canvas.height = outH;

          // Optional: favor speed over quality for small previews
          this.ctx.imageSmoothingEnabled = true;
          this.ctx.imageSmoothingQuality = 'high';

          // Draw scaled frame
          this.ctx.drawImage(vid, 0, 0, outW, outH);

          // Export LOWER-QUALITY JPEG
          const JPEG_QUALITY = 0.5; // adjust 0..1 to taste
          const image = canvas.toDataURL('image/jpeg', JPEG_QUALITY);

          // Restore canvas to its original size to avoid side effects in your UI
          canvas.width = prevW;
          canvas.height = prevH;

          this.clearOverlay();
          this.capturingImage = false;

          const { id } = target;
          set(`camerapreview.${id}`, image);
          this.$emit('preview-updated', { id, image, at: Date.now() });
        }
      },
      async sendData(data) {
        if (this.streaming === null || this.dataChannelOpen === false) return;

        const m = JSON.stringify(data);
        console.log('Send DC: ', m);

        this.streaming.data({
          text: m,
          error: () => {},
          success: () => {},
        });
      },

      // Handle incoming message on the data channel
      processData(message) {
        let data = null;

        try {
          data = JSON.parse(message);
        } catch (e) {
          console.log(
            'Error in decoding data channel message to json: ',
            message
          );
        }

        if (data == null) return;

        if (data?.response === 'mmctrl' && data?.data?.status === 'complete')
          this.$parent.mmctrl_ok(data);

        console.debug('Data: ', data);

        if (data?.action?.command === 'healthCheck') {
          const statsData = data?.action?.data ?? {};
          this.$emit('statsResponse', statsData);
          return;
        }

        if ('version' in data) {
          this.connectionEstablished = true;
          if (this.connectionTimer !== -1) this.stopConnectionTimer();

          this.viewCameraStart();
        }

        // Detect play / pause state
        if ('ts' in data) {
          if (this.connectionTimer !== -1) {
            this.stopConnectionTimer();

            if (this.connectionTimer == false) this.connectionTimer = true;
          }

          const currentTimeStamp = data.ts;

          if ('date' in data) {
            this.currentDate = data.date;
            try {
              const tms = this.parseDateTime(this.currentDate).getTime();
              if (Number.isFinite(tms)) this.$emit('time', tms);
            } catch {
              /* Ignore */
            }
          }

          if (this.ignoreTimestampMessages > 0) {
            this.ignoreTimestampMessages -= 1;
            this.lastTimeStamp = currentTimeStamp;
            return;
          }

          const pauseMismatch =
            (this.userPaused && !('pause' in data)) ||
            ('pause' in data &&
              (data.pause === true) != this.userPaused &&
              this.userPausedAt);
          const pauseCloseEnough =
            this.userPaused == this.janusPaused &&
            Math.abs(this.userPausedAt - data.ts) < 1000;

          if (pauseMismatch && !pauseCloseEnough) {
            let noop = false;
            this.currentDate = this.formatDate(new Date(this.userPausedAt));
            switch (this.userPauseIgnoredCount) {
              case 0:
              case 2:
              case 5:
              case 15:
              case 25:
              case 35:
              case 50:
              case 70:
              case 90:
                if (this.userPaused) {
                  this.pause();
                } else this.play();
                this.ignoreTimestampMessages = 1;
                break;
              case 10:
              case 30:
              case 60:
                if (this.userPaused) {
                  this.pause(this.userPausedAt);
                } else this.play(this.userPausedAt);
                this.ignoreTimestampMessages = 1;
                break;
              case 20:
              case 40:
              case 80:
                if (this.userPaused) {
                  this.playmode === 'lv'
                    ? this.pause(this.userPausedAt, false)
                    : this.pause(this.userPausedAt - data.ts, true);
                } else
                  this.playmode === 'lv'
                    ? this.play(this.userPausedAt, false)
                    : this.play(this.userPausedAt - data.ts, true);
                this.ignoreTimestampMessages = 1;
                break;
              case 100:
                this.userPauseIgnoredCount = 0;
                break;
              default:
                noop = true;
                // Try leaving it for a few seconds
                break;
            }
            if (!noop)
              console.warn(
                `Pause mismatch! Attempting correction to ${this.userPausedAt}. (Step ${this.userPauseIgnoredCount})`
              );
            this.userPauseIgnoredCount += 1;
          } else if (
            pauseMismatch &&
            pauseCloseEnough &&
            this.userPauseIgnoredCount > 0
          ) {
            console.warn(`Pause mismatch ignored`);
            this.userPauseIgnoredCount = 0;
          } else {
            this.userPauseIgnoredCount = 0;
            this.playing = 'pause' in data && data.pause === true;
            this.lastTimeStamp = currentTimeStamp;
          }
        }

        if ('response' in data) {
          if (data.response != 'make-v' && data.response != 'mmctrl') return;

          let status = data.data.status;

          if (this.clipStatus !== status) {
            this.clipStatus = status;
            this.$emit('clipStatus', status);
          }
        }

        // Occasionally make a fake object detection for testing.
        //  if (Math.random() > 0.9) {
        //    data.objectDetections = [];
        //    data.objectDetections[0] = {};
        //    data.objectDetections[0].ymin = 100;
        //    data.objectDetections[0].ymax = 150;
        //    data.objectDetections[0].xmin = 100;
        //    data.objectDetections[0].xmax = 150;
        //    data.objectDetections[0].class = "class";
        //    data.objectDetections[0].confidence = 0.4;
        //  }

        // Receive and render detected object bounding rectangles
        if ('objectDetections' in data) {
          if (data.objectDetections && data.objectDetections.length)
            console.table(data.objectDetections);
          awsInfo.objectDetections = data.objectDetections;
          if (awsInfo.objectDetections == null) return;
          this.drawOverlay();
        }

        // if (Math.random() > 0.94) {
        // data.viewCamera = "OWxEfjh1Mu8V8lA5r5Am3";
        // }

        /*
        Use - cases to satisfy:
        1. switch to camera ...should switch to that camera but only if not yet connected to that camera
        2. switch to camera + ts ...same rules as above, only switch if not already connected & once connected, go to ts.
        Obviously, the trick use -case; if switching to a camera that we're already connected to, then we do not need to reconnect
        BUT if there is a ts specified, then we need to act on the vt/seek ts
        */
        const cam = data.viewCamera;
        const camstart = data.viewCameraStart;
        if (cam) {
          if (camstart) this.$store.commit('setViewCameraStart', camstart);
          else this.$store.commit('setViewCameraStart', null);

          if (this.camera.id != cam) this.$parent.viewLiveStream({ id: cam });
          else if (camstart) this.viewCameraStart();
        }
      },

      viewCameraStart() {
        const ts = this.$store.getters.viewCameraStart;
        if (!ts) return;
        console.log('viewCameraStart seek to ', ts);
        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data: {
              abs: ts,
            },
          },
        };
        this.sendData(message);
        this.$store.commit('setViewCameraStart', null);
      },

      pause(to = null, rel = false) {
        this.userPaused = true;
        if (!to && !this.userPausedAt)
          this.userPausedAt = this.parseDateTime(this.currentDate).getTime();
        else if (to && !this.userPausedAt) this.userPausedAt = to;
        const data =
          to != null
            ? rel
              ? { rel: to, pause: 1000 * 60 * 60 * 24, forward: false }
              : { abs: to, pause: -1, forward: false }
            : { pause: -1 };
        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data,
          },
        };

        this.ignoreTimestampMessages = 1;
        this.sendData(message);
      },
      play(to = 0, rel = false) {
        this.userPaused = false;
        this.userPausedAt = 0;
        const data = to
          ? rel
            ? { rel: to, pause: 0, forward: true }
            : { abs: to, pause: 0, forward: true }
          : { pause: 0 };
        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data,
          },
        };

        this.sendData(message);
      },
      abs(to) {
        const data = { abs: to };
        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data,
          },
        };
        this.sendData(message);
      },

      /*
        setIFrameMode( true ) sends a message to TED to set the I-Frame only video mode
      */
      // eslint-disable-next-line
      sendIFrameMode(val) {
        const message = {
          topic: 'cmd/devices/tempest-dev/data-channel-relay',
          destination: `mplay`,
          action: {
            command: 'i-frames',
            data: {
              // duration: 60000,
            },
          },
        };
        this.sendData(message);
      },

      sendBitrate(val) {
        const message = {
          topic: 'cmd/devices/tempest-dev/data-channel-relay',
          destination: `mplay`,
          sessionId: '123',
          action: {
            command: 'setBitrate',
            data: {
              bitrate: val,
            },
          },
        };
        this.sendData(message);
      },

      /*
        setTxMax( bps ) sends a message to TED to set the outgoing bandwidth limit
      */
      setTxMax() {
        const message = {
          topic: 'cmd/devices/tempest-dev/data-channel-relay',
          action: {
            destination: `bandwidth-control/${this.camera.id}`,
            command: 'setTxMax',
            data: {
              txMax: this.txMax,
            },
          },
        };
        this.sendData(message);
      },

      filter() {
        const message = {
          topic: 'cmd/devices/tempest-dev/data-channel-relay',
          action: {
            command: 'qe',
            destination: `inbox-app/${this.camera.id}`,
            data: {
              from: this.filterTime,
              to:
                this.eventTo !== null && this.eventTo !== undefined
                  ? this.eventTo
                  : Date.now(),
            },
          },
        };
        this.sendData(message);
      },
      rewind(iData) {
        this.userPausedAt = 0;
        this.userPaused = false;
        let number;
        if (iData.rel > 0) {
          number = true;
        } else number = false;
        this.playmode = 'vt';
        const data = iData ?? { rel: -5000, pause: 200 };
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data: {
              rel: data.rel,
              pause: data.pause,
              forward: number,
            },
          },
        };

        this.sendData(message);
      },
      fastForward(iData) {
        this.userPausedAt = 0;
        this.userPaused = false;
        this.playmode = 'vt';
        const data = iData ?? { rel: 5000 };

        const now = Date.now();
        const currentDateTime = this.parseDateTime(this.currentDate).getTime();
        if (Math.abs(now - currentDateTime) < iData.rel) {
          this.switchToLiveview();
        } else {
          const message = {
            topic: 'cmd/devices/hilary-dev/data-channel-relay',
            destination: 'mplay',
            action: {
              command: 'vt',
              data,
            },
          };

          this.sendData(message);
        }
      },
      checkMediaReports() {
        console.log('checkMediaReports');
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          action: {
            destination: 'mplay',
            command: 'report',
            data: {
              ts: false,
              date: false,
              version: true,
              debug: false,
              source: false,
            },
          },
        };
        this.sendData(message);
      },
      getMediaReports() {
        console.log('getMediaReports');
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          action: {
            destination: 'mplay',
            command: 'report',
            data: {
              ts: true,
              date: true,
              version: true,
              debug: true,
              source: true,
            },
          },
        };
        this.sendData(message);
      },
      startSeekTask() {
        this.playmode = 'vt';
        console.log('Start Seek Task');
        if (this.seekTask != null) this.stopSeekTask();
        this.handleSeekTask();
        this.seekTask = setInterval(this.handleSeekTask, 100);
      },
      handleSeekTask() {
        console.log('Handle Seek Task');
        // allow the scrubber to affect the skip point from + 4 seconds to - 4 seconds
        const seekAmount =
          (this.scrubber - 50 >= 0 ? 1000 : -1000) +
          Number.parseInt(((this.scrubber - 50) / 50) * 7 * 1000, 10);
        console.log(seekAmount);
        this.rewind({
          rel: seekAmount,
          pause: 200,
        });
      },
      stopSeekTask() {
        console.log('Stop Seek Task');
        if (this.seekTask == null) return;
        clearInterval(this.seekTask);
        this.seekTask = null;
      },
      switchToLiveview() {
        this.userPaused = false;
        this.userPausedAt = 0;
        this.playmode = 'lv';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'lv',
          },
        };

        this.sendData(message);
      },
      async havePhoto(id) {
        try {
          if (!id) return false;
          const image = await get(`camerapreview.${id}`);
          this.previewImage = image || null;
          return !!image;
        } catch (e) {
          console.warn('havePhoto error', e);
          this.previewImage = null;
          return false;
        }
      },
      getDeviceStats() {
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          action: {
            destination: 'health-monitor',
            command: 'healthCheck',
          },
        };
        this.sendData(message);
      },
      handleFullscreenEvent() {
        var fullscreenElement =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement;

        let isFullscreen =
          fullscreenElement !== null && fullscreenElement !== undefined;

        if (this.fullscreen !== isFullscreen) {
          this.fullscreen = isFullscreen;
        }

        this.$nextTick(() => {
          this.setupCanvas(false);
        });
      },
      toggleFullScreen() {
        this.$emit('toggle-fullscreen');
      },
      exitFullscreenIfActive() {
        try {
          const d = document;
          const isFs =
            d.fullscreenElement ||
            d.webkitFullscreenElement ||
            d.mozFullScreenElement ||
            d.msFullscreenElement;

          if (!isFs) return;

          const exit =
            d.exitFullscreen ||
            d.webkitExitFullscreen ||
            d.mozCancelFullScreen ||
            d.msExitFullscreen;

          if (typeof exit === 'function') exit.call(d);
        } catch (e) {
          console.warn('Failed to exit fullscreen:', e);
        } finally {
          // Let your existing fullscreenchange handler also update this,
          // but set it eagerly so the UI feels instant.
          this.fullscreen = false;
        }
      },
      openPopper() {
        this.$refs.datetimePicker.showPicker();
      },
      seekToTime() {
        this.showPopper = false;

        let time = Date.parse(this.dateTime);

        if (time > Date.now() || time == Date.now()) {
          return;
        }

        this.userPausedAt = 0;
        this.userPaused = false;

        let date = new Date(time);

        this.$emit('seekTime', date);

        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data: {
              abs: time,
            },
          },
        };
        this.sendData(message);
      },
      calculateVideoSize(screenWidth, screenHeight, videoWidth, videoHeight) {
        const videoRatio = videoWidth / videoHeight;
        const screenRatio = screenWidth / screenHeight;
        let scaledWidth =
          screenRatio > videoRatio
            ? videoWidth * (screenHeight / videoHeight)
            : screenWidth;
        let scaledHeight =
          screenRatio > videoRatio
            ? screenHeight
            : videoHeight * (screenWidth / videoWidth);
        return { scaledWidth, scaledHeight };
      },
      startThumbnailTimer() {
        if (this.thumbnailTimer !== -1) return;
        const cam = this.camera;
        this.thumbnailTimer = setInterval(() => {
          this.captureImage(cam);
        }, 10 * 1000);
      },
      stopThumbnailTimer() {
        if (this.thumbnailTimer == -1) return;
        clearInterval(this.thumbnailTimer);
        this.thumbnailTimer = -1;
      },
      parseDateTime(str) {
        let data = str.split(' ');
        let date = data[0].split('.').reverse().join('/');
        let time = data[1];
        return new Date(`${date} ${time} GMT`);
      },
      formatDate(date) {
        var day = date.getDate();
        var month = date.getMonth() + 1; // Months are zero-based
        var year = date.getFullYear();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();

        // Add leading zeros if necessary
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        var formattedDate =
          day +
          '.' +
          month +
          '.' +
          year +
          ' ' +
          hours +
          ':' +
          minutes +
          ':' +
          seconds;
        return formattedDate;
      },
      handleKeys(event) {
        let code = event.code;
        if (
          event.target.isContentEditable ||
          ['INPUT', 'TEXTAREA', 'SELECT'].includes(event.target.tagName)
        )
          return;
        switch (code) {
          case 'KeyA':
          case 'KeyJ':
          case 'Numpad4':
            event.preventDefault();
            this.rewind({ rel: -20000, pause: 200 });
            break;
          case 'ArrowLeft':
            event.preventDefault();
            this.rewind({ rel: -5000, pause: 200 });
            break;
          case 'KeyD':
          case 'KeyL':
          case 'Numpad6':
            event.preventDefault();
            this.fastForward({ rel: 20000 });
            break;
          case 'ArrowRight':
            event.preventDefault();
            this.rewind({ rel: 5000, pause: 200 });
            break;
        }
        if (event.repeat) return;
        switch (code) {
          // Top Row
          case 'KeyQ':
          case 'ArrowDown':
          case 'Numpad7':
            event.preventDefault();
            this.goToPreviousEvent();
            break;
          case 'KeyW':
          case 'Numpad8':
            event.preventDefault();
            this.$parent.doJpegCapture(this.lastTimeStamp);
            break;
          case 'KeyE':
          case 'ArrowUp':
          case 'Numpad9':
            event.preventDefault();
            this.goToNextEvent();
            break;
          case 'KeyR':
          case 'NumpadDivide':
            event.preventDefault();
            this.exitFullscreenIfActive();
            this.$emit('openClipMaker', this.currentDate);
            break;

          // Middle Row
          case 'KeyS':
          case 'KeyK':
          case 'Space':
          case 'Numpad5':
            event.preventDefault();
            this.togglePlay();
            break;
          case 'KeyF':
          case 'NumpadMultiply':
            event.preventDefault();
            this.toggleFullScreen();
            break;

          // Bottom Row
          case 'KeyZ':
          case 'Numpad1':
            event.preventDefault();
            this.setRememberedTime(
              this.lastTimeStamp || this.parseDateTime(this.currentDate)
            );
            break;
          case 'KeyX':
          case 'Numpad2':
            event.preventDefault();
            this.lvMode();
            break;
          case 'KeyC':
          case 'Numpad3':
            event.preventDefault();
            this.playRememberedTime();
            break;
          case 'KeyV':
          case 'Numpad0':
            event.preventDefault();
            this.openPopper();
            break;

          //Misc
          case 'Escape':
            this.showPopper = false;
        }
      },
      startConnectionTimer() {
        if (this.connectionTimer !== -1) this.stopConnectionTimer();

        this.connectionEstablished = false;

        this.connectionTimer = setInterval(this.handleConnectionCallback, 250);
      },
      handleConnectionCallback() {
        this.checkMediaReports();

        this.connectionRetries = this.connectionRetries + 1;

        if (this.connectionRetries >= 8 || this.connectionEstablished == true)
          this.stopConnectionTimer();
      },
      stopConnectionTimer() {
        if (this.connectionTimer !== -1) {
          clearInterval(this.connectionTimer);
          this.connectionTimer = -1;
        }

        this.connectionRetries = 0;
      },
      setRememberedTime(value) {
        let ts;

        if (value == null) {
          ts =
            this.lastTimeStamp ||
            this.parseDateTime(this.currentDate).getTime();
        } else if (value instanceof Date) {
          ts = value.getTime();
        } else if (typeof value === 'number') {
          ts = value; // assume ms epoch
        } else if (typeof value === 'string') {
          ts = this.parseDateTime(value).getTime();
        } else {
          // Fallback
          ts = this.parseDateTime(this.currentDate).getTime();
        }

        // Commit as a plain number (ms)
        this.$store.commit('setRememberedTime', ts);
      },
      playRememberedTime() {
        const time =
          typeof this.rememberedTime === 'number'
            ? this.rememberedTime
            : new Date(this.rememberedTime).getTime();

        this.userPausedAt = 0;
        this.userPaused = false;

        this.playmode = 'vt';
        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data: {
              abs: time,
              pause: -1,
            },
          },
        };

        this.ignoreTimestampMessages = 1;
        this.sendData(message);
      },
      goToPreviousEvent() {
        const date = this.parseDateTime(this.currentDate);
        const time = date.getTime();

        let eventsBefore = this.filteredEvents.filter(
          (event) => event.data.s <= time
        );

        if (eventsBefore.length == 0) return;

        let previousEvent = eventsBefore[0];

        if (time - previousEvent.data.s <= 2000) {
          let eventBefore =
            eventsBefore.length >= 2 ? eventsBefore[1] : previousEvent;
          this.playEvent(eventBefore, false);
        } else {
          this.playEvent(previousEvent, false);
        }
      },
      goToNextEvent() {
        const date = this.parseDateTime(this.currentDate);
        const time = date.getTime();

        let eventsAfter = this.filteredEvents.filter(
          (event) => event.data.s > time
        );

        if (eventsAfter.length == 0) return;

        let nextEvent = eventsAfter[eventsAfter.length - 1];

        this.playEvent(nextEvent, true);
      },
      playEvent(event, forward) {
        const time = event.data.s;
        forward = forward !== undefined && forward !== null ? forward : false;
        this.$emit('focusEvent', time);

        this.playmode = 'vt';

        // Build data payload for VT seek
        const data = { abs: time, forward };

        // If paused, resume as part of the seek
        if (this.userPaused || this.playing) {
          this.userPaused = false; // clear local flag
          this.userPausedAt = 0;
          data.pause = 0; // instruct remote to resume
        }

        const message = {
          topic: 'cmd/devices/hilary-dev/data-channel-relay',
          destination: 'mplay',
          action: {
            command: 'vt',
            data,
          },
        };
        this.sendData(message);
      },
      seekTo(ms) {
        const t = Math.round(Number(ms));
        if (!Number.isFinite(t) || t <= 0 || t > Date.now()) return;

        // Preserve current pause/play state while moving the playhead
        if (this.userPaused) {
          this.userPausedAt = 0;
          this.userPaused = false;
          this.abs(t);
        } else {
          this.play(t);
        }
      },
    },
  };
</script>

<style scoped>
  button:not(:disabled) {
    cursor: pointer;
  }

  .loadingPage {
    display: grid;
    position: absolute;
    top: 0;
    left: 0;
    place-items: center;
    opacity: 0;
    z-index: 10;
    transition: opacity 1s ease-in-out;
    container-type: size;
    background: var(--bg);
    width: 100%;
    height: calc(100% - 50px);
    overflow: hidden;
    color: var(--text);
  }

  .loadingPage.loading {
    opacity: 1;
  }

  .loadingPage > * {
    position: relative;
    z-index: 1;
  }

  .loadingPageThumb {
    position: absolute;
    transform: scale(1);
    z-index: 0;
    filter: grayscale(80%) brightness(0.6) blur(3px);
    inset: 0;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    content: '';
  }
  .loadingPageThumb.overrideShowThumb {
    opacity: 1;
  }

  .loadingPage p {
    flex: 0 1 auto;
    z-index: 15;
    margin-top: 10cqh;
    min-width: 0;
    max-width: 600px;
    content: var(--thumb-cam-name);
    color: var(--text);
    font-size: min(10cqh, 2rem);
    text-align: center;
    text-shadow: var(--shadow);
  }

  * {
    touch-action: manipulation;
  }

  .tapBack div {
    width: 40vw;
    height: 100%;
  }

  .tapBack {
    display: flex;
    position: absolute;
    top: 0;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - 44px);
  }

  .play {
    background-image: url("data:image/svg+xml,%3Csvg width='23' height='23' viewBox='0 0 23 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.15962 0.841309H1.76962C0.871365 0.841309 0.143188 1.56949 0.143188 2.46774V21.2149C0.143188 22.1131 0.871365 22.8413 1.76962 22.8413H7.15962C8.05787 22.8413 8.78605 22.1131 8.78605 21.2149V2.46774C8.78605 1.56949 8.05787 0.841309 7.15962 0.841309Z' fill='%23EAEBEC'/%3E%3Cpath d='M20.5168 0.841309H15.1268C14.2285 0.841309 13.5003 1.56949 13.5003 2.46774V21.2149C13.5003 22.1131 14.2285 22.8413 15.1268 22.8413H20.5168C21.415 22.8413 22.1432 22.1131 22.1432 21.2149V2.46774C22.1432 1.56949 21.415 0.841309 20.5168 0.841309Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
  }

  .pause {
    background-image: url("data:image/svg+xml,%3Csvg width='22' height='23' viewBox='0 0 22 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.0803 9.71909L2.36916 0.372901C2.11674 0.256068 1.83908 0.204161 1.56145 0.221906C1.28381 0.239651 1.01503 0.326484 0.779572 0.4745C0.544111 0.622515 0.349447 0.827014 0.2133 1.06938C0.077153 1.31174 0.00384762 1.58428 5.65776e-05 1.86217V20.5465C-0.00230074 20.8318 0.0690426 21.1128 0.207191 21.3625C0.34534 21.6121 0.545622 21.822 0.788679 21.9717C1.03174 22.1214 1.30935 22.206 1.59468 22.2172C1.88002 22.2284 2.16342 22.1659 2.41751 22.0358L21.0803 12.6896C21.3567 12.5509 21.5892 12.3382 21.7516 12.0753C21.914 11.8123 22 11.5093 22 11.2003C22 10.8913 21.914 10.5884 21.7516 10.3254C21.5892 10.0624 21.3567 9.84967 21.0803 9.71103V9.71909Z' fill='%23EAEBEC'/%3E%3C/svg%3E%0A");
  }

  .Lv {
    transition:
      color 0.2s ease,
      text-decoration 0.2s ease;
    background-color: transparent;
    width: 42px;
    height: 42px;
    color: var(--text-faint);
    font-weight: 500;
    font-size: 20px;
  }

  .redHighlight {
    color: var(--error);
  }

  .playPause {
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 42px;
    height: 42px;
  }

  .fast-forward {
    background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.25 11.25C16.25 12.4861 15.8834 13.6945 15.1967 14.7223C14.5099 15.7501 13.5338 16.5512 12.3918 17.0242C11.2497 17.4973 9.99307 17.6211 8.78069 17.3799C7.56831 17.1388 6.45466 16.5435 5.58059 15.6694C4.70651 14.7953 4.11125 13.6817 3.8701 12.4693C3.62894 11.2569 3.75271 10.0003 4.22576 8.85823C4.6988 7.71619 5.49988 6.74007 6.52769 6.05331C7.5555 5.36656 8.76387 5 10 5H12.5V8.125L16.25 4.375L12.5 0.625V3.75H10C8.51664 3.75 7.0666 4.18987 5.83323 5.01398C4.59986 5.83809 3.63856 7.00943 3.07091 8.37987C2.50325 9.75032 2.35472 11.2583 2.64411 12.7132C2.9335 14.168 3.64781 15.5044 4.6967 16.5533C5.7456 17.6022 7.08197 18.3165 8.53683 18.6059C9.99168 18.8953 11.4997 18.7468 12.8701 18.1791C14.2406 17.6114 15.4119 16.6501 16.236 15.4168C17.0601 14.1834 17.5 12.7334 17.5 11.25H16.25Z' fill='white'/%3E%3Cpath d='M6.19598 13.3573L8.00198 11.4393C8.15132 11.2807 8.27265 11.1383 8.36598 11.0123C8.45932 10.8863 8.52698 10.7673 8.56898 10.6553C8.61098 10.5433 8.63198 10.429 8.63198 10.3123C8.63198 10.093 8.55965 9.92268 8.41498 9.80134C8.27498 9.67534 8.09532 9.61234 7.87598 9.61234C7.64265 9.61234 7.43732 9.67068 7.25998 9.78734C7.08265 9.90401 6.92398 10.086 6.78398 10.3333L6.22398 9.87134C6.41532 9.54001 6.65098 9.29034 6.93098 9.12234C7.21098 8.94968 7.53532 8.86334 7.90398 8.86334C8.20732 8.86334 8.47332 8.92401 8.70198 9.04534C8.93065 9.16668 9.10798 9.33701 9.23398 9.55634C9.35998 9.77101 9.42298 10.0207 9.42298 10.3053C9.42298 10.5107 9.39732 10.695 9.34598 10.8583C9.29932 11.017 9.21765 11.178 9.10098 11.3413C8.98432 11.5 8.82332 11.6867 8.61798 11.9013L7.23198 13.3363L6.19598 13.3573ZM6.19598 13.8333V13.3573L6.88898 13.1123H9.52098V13.8333H6.19598Z' fill='white'/%3E%3Cpath d='M12.2301 13.9033C11.8614 13.9033 11.5231 13.8007 11.2151 13.5953C10.9118 13.3853 10.6691 13.0913 10.4871 12.7133C10.3051 12.3353 10.2141 11.8897 10.2141 11.3763C10.2141 10.863 10.3028 10.4197 10.4801 10.0463C10.6621 9.66834 10.9048 9.37668 11.2081 9.17134C11.5114 8.96601 11.8474 8.86334 12.2161 8.86334C12.5894 8.86334 12.9278 8.96601 13.2311 9.17134C13.5344 9.37668 13.7748 9.66834 13.9521 10.0463C14.1341 10.4197 14.2251 10.8653 14.2251 11.3833C14.2251 11.8967 14.1341 12.3423 13.9521 12.7203C13.7748 13.0983 13.5344 13.39 13.2311 13.5953C12.9324 13.8007 12.5988 13.9033 12.2301 13.9033ZM12.2161 13.1473C12.4588 13.1473 12.6688 13.082 12.8461 12.9513C13.0234 12.8207 13.1611 12.6247 13.2591 12.3633C13.3618 12.102 13.4131 11.773 13.4131 11.3763C13.4131 10.9843 13.3618 10.6577 13.2591 10.3963C13.1611 10.135 13.0211 9.94134 12.8391 9.81534C12.6618 9.68468 12.4541 9.61934 12.2161 9.61934C11.9781 9.61934 11.7681 9.68468 11.5861 9.81534C11.4088 9.94134 11.2711 10.135 11.1731 10.3963C11.0751 10.653 11.0261 10.9797 11.0261 11.3763C11.0261 11.773 11.0751 12.102 11.1731 12.3633C11.2711 12.6247 11.4088 12.8207 11.5861 12.9513C11.7681 13.082 11.9781 13.1473 12.2161 13.1473Z' fill='white'/%3E%3C/svg%3E%0A");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 42px;
    height: 42px;
  }

  .rewind {
    background-image: url("data:image/svg+xml,%0A%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.75 11.25C3.75 12.4861 4.11655 13.6945 4.80331 14.7223C5.49007 15.7501 6.46619 16.5512 7.60823 17.0242C8.75026 17.4973 10.0069 17.6211 11.2193 17.3799C12.4317 17.1388 13.5453 16.5435 14.4194 15.6694C15.2935 14.7953 15.8887 13.6817 16.1299 12.4693C16.3711 11.2569 16.2473 10.0003 15.7742 8.85823C15.3012 7.71619 14.5001 6.74007 13.4723 6.05331C12.4445 5.36656 11.2361 5 10 5H7.5V8.125L3.75 4.375L7.5 0.625V3.75H10C11.4834 3.75 12.9334 4.18987 14.1668 5.01398C15.4001 5.83809 16.3614 7.00943 16.9291 8.37987C17.4968 9.75032 17.6453 11.2583 17.3559 12.7132C17.0665 14.168 16.3522 15.5044 15.3033 16.5533C14.2544 17.6022 12.918 18.3165 11.4632 18.6059C10.0083 18.8953 8.50032 18.7468 7.12987 18.1791C5.75942 17.6114 4.58809 16.6501 3.76397 15.4168C2.93986 14.1834 2.5 12.7334 2.5 11.25H3.75Z' fill='white'/%3E%3Cpath d='M6.19598 13.3573L8.00198 11.4393C8.15132 11.2807 8.27265 11.1383 8.36598 11.0123C8.45932 10.8863 8.52698 10.7673 8.56898 10.6553C8.61098 10.5433 8.63198 10.429 8.63198 10.3123C8.63198 10.093 8.55965 9.92268 8.41498 9.80134C8.27498 9.67534 8.09532 9.61234 7.87598 9.61234C7.64265 9.61234 7.43732 9.67068 7.25998 9.78734C7.08265 9.90401 6.92398 10.086 6.78398 10.3333L6.22398 9.87134C6.41532 9.54001 6.65098 9.29034 6.93098 9.12234C7.21098 8.94968 7.53532 8.86334 7.90398 8.86334C8.20732 8.86334 8.47332 8.92401 8.70198 9.04534C8.93065 9.16668 9.10798 9.33701 9.23398 9.55634C9.35998 9.77101 9.42298 10.0207 9.42298 10.3053C9.42298 10.5107 9.39732 10.695 9.34598 10.8583C9.29932 11.017 9.21765 11.178 9.10098 11.3413C8.98432 11.5 8.82332 11.6867 8.61798 11.9013L7.23198 13.3363L6.19598 13.3573ZM6.19598 13.8333V13.3573L6.88898 13.1123H9.52098V13.8333H6.19598Z' fill='white'/%3E%3Cpath d='M12.2301 13.9033C11.8614 13.9033 11.5231 13.8007 11.2151 13.5953C10.9118 13.3853 10.6691 13.0913 10.4871 12.7133C10.3051 12.3353 10.2141 11.8897 10.2141 11.3763C10.2141 10.863 10.3028 10.4197 10.4801 10.0463C10.6621 9.66834 10.9048 9.37668 11.2081 9.17134C11.5114 8.96601 11.8474 8.86334 12.2161 8.86334C12.5894 8.86334 12.9278 8.96601 13.2311 9.17134C13.5344 9.37668 13.7748 9.66834 13.9521 10.0463C14.1341 10.4197 14.2251 10.8653 14.2251 11.3833C14.2251 11.8967 14.1341 12.3423 13.9521 12.7203C13.7748 13.0983 13.5344 13.39 13.2311 13.5953C12.9324 13.8007 12.5988 13.9033 12.2301 13.9033ZM12.2161 13.1473C12.4588 13.1473 12.6688 13.082 12.8461 12.9513C13.0234 12.8207 13.1611 12.6247 13.2591 12.3633C13.3618 12.102 13.4131 11.773 13.4131 11.3763C13.4131 10.9843 13.3618 10.6577 13.2591 10.3963C13.1611 10.135 13.0211 9.94134 12.8391 9.81534C12.6618 9.68468 12.4541 9.61934 12.2161 9.61934C11.9781 9.61934 11.7681 9.68468 11.5861 9.81534C11.4088 9.94134 11.2711 10.135 11.1731 10.3963C11.0751 10.653 11.0261 10.9797 11.0261 11.3763C11.0261 11.773 11.0751 12.102 11.1731 12.3633C11.2711 12.6247 11.4088 12.8207 11.5861 12.9513C11.7681 13.082 11.9781 13.1473 12.2161 13.1473Z' fill='white'/%3E%3C/svg%3E%0A");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 42px;
    height: 42px;
  }

  .calendar {
    margin-left: 10px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 20 20'%3E%3Cpath fill='white' d='M17 5.5A2.5 2.5 0 0 0 14.5 3h-9A2.5 2.5 0 0 0 3 5.5v3.756c.318-.112.653-.19 1-.229V7h12v7.5a1.5 1.5 0 0 1-1.5 1.5H9.121l1 1H14.5a2.5 2.5 0 0 0 2.5-2.5v-9ZM5.5 4h9A1.5 1.5 0 0 1 16 5.5V6H4v-.5A1.5 1.5 0 0 1 5.5 4Zm1.096 12.303a3.5 3.5 0 1 1 .707-.707l2.55 2.55a.5.5 0 0 1-.707.708l-2.55-2.55ZM7 13.5a2.5 2.5 0 1 0-5 0a2.5 2.5 0 0 0 5 0Z'/%3E%3C/svg%3E");
    background-position: 0px center;
    background-size: 33px;
    background-repeat: no-repeat;
    background-color: transparent;
    height: 42px;
  }

  .range {
    background-color: var(--text);
    width: clamp(0px, 70vw, 600px);
  }

  .mediaTools {
    display: flex;
    bottom: 0;
    justify-content: space-between;
    align-items: center;
    /* position: absolute; */
    border-radius: 0px 0px 0px 10px;
    background: var(--bg);
    width: 100%;
    height: 50px;
  }

  .mediaTools button {
    border: none;
  }

  .video-wrapper {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: auto;
    margin-left: auto;
    background-color: var(--bg);
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
  }

  .fullscreen {
    position: absolute !important;
    top: 0;
    left: 0;
    background: var(--bg);
    width: 100%;
    height: calc(100% - 36px);
  }

  .fsButton {
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Cpath fill='white' d='M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'/%3E%3C/svg%3E");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 42px;
    height: 42px;
  }

  .efs {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Cpath fill='white' d='M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z'/%3E%3C/svg%3E");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 42px;
    height: 42px;
  }

  .endButtons {
    display: flex;
    justify-content: flex-end;
    min-width: 200px;
  }

  .video {
    width: 100%;
    max-width: 100%;
    height: calc(100% - 50px);
    max-height: 100%;
    object-fit: contain;
  }

  .canvas {
    position: absolute;
    top: 0;
    bottom: 0;
  }

  input[type='range'] {
    -webkit-appearance: none;
    appearance: none;
    margin: 18px 0;
    border-radius: 50px;
  }

  input[type='range']:focus {
    outline: none;
  }

  input[type='range']::-webkit-slider-runnable-track {
    cursor: pointer;
    border-radius: 50px;
    height: 8.4px;
  }

  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    cursor: pointer;
    margin-top: -13px;
    border: none;
    border-radius: 50%;
    background: var(--accent);
    width: 34px;
    height: 34px;
  }

  .picker {
    border: none;
    width: 0;
    height: 0;
    color: var(--text);
  }

  .picker::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }

  .timego {
    border-radius: var(--border-radius);
    background-color: var(--success);
    width: 75px;
    height: 50px;
    color: var(--text);
  }

  .startButtons {
    display: flex;
    align-items: center;
    min-width: 200px;
  }

  .stats {
    width: 485px;
  }

  .stats div {
    display: inline-block;
    background-color: var(--bg);
    width: 120px;
    color: var(--text);
    font-size: 12px;
  }

  .time-text {
    margin-left: 40px;
    color: var(--text);
  }

  .hide-time-text {
    visibility: hidden;
  }

  .nav-buttons {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-right: 16px;
  }
  .nav-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
    border-radius: var(--border-radius);
    background: transparent;
    width: 36px;
    height: 36px;
  }
  .nav-btn svg {
    pointer-events: none;
    color: var(--text);
  }

  .loading-holder {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    user-select: none;
  }

  * {
    user-select: none !important;
  }
</style>
